import { RouteComponentProps, withRouter } from 'react-router';
import Signup from './signup';

export type IProps = RouteComponentProps;

export default withRouter(Signup);
